import NetworkSpeed from "network-speed";
import MobileDetect from "mobile-detect";

let networkEffectiveType = (navigator as any).connection?.effectiveType;
const md = new MobileDetect(window.navigator.userAgent);

let arQuicklookSupport;

export enum NetworkEffectiveType {
  "Slow2G" = "slow-2g",
  "2G" = "2g",
  "3G" = "3g",
  "4G" = "4g",
}

export enum DeviceGrade {
  "Low",
  "Medium",
  "High",
  "Unknown",
}

class DeviceGradeDetection {
  static async getNetworkEffectiveType(): Promise<NetworkEffectiveType> {
    if (!networkEffectiveType) {
      return NetworkEffectiveType["4G"];
      // try {
      //   const testNetworkSpeed = new NetworkSpeed();
      //   const baseUrl = "https://eu.httpbin.org/stream-bytes/500000";
      //   const fileSizeInBytes = 500000;
      //   const speed = await testNetworkSpeed.checkDownloadSpeed(
      //     baseUrl,
      //     fileSizeInBytes
      //   );
      //   const kbps = parseFloat(speed.kbps);
      //   if (kbps <= 50) networkEffectiveType = NetworkEffectiveType.Slow2G;
      //   if (kbps <= 70) networkEffectiveType = NetworkEffectiveType["2G"];
      //   if (kbps <= 700) networkEffectiveType = NetworkEffectiveType["3G"];
      //   networkEffectiveType = NetworkEffectiveType["4G"];
      // } catch (error) {
      //   networkEffectiveType = NetworkEffectiveType["4G"];
      // }
    }
    return networkEffectiveType;
  }

  static get isMobile(): boolean {
    return !!md.mobile() || DeviceGradeDetection.isIPad;
  }

  static get isIPad(): boolean {
    return (
      navigator.userAgent.indexOf("iPad") > -1 ||
      (navigator.maxTouchPoints &&
        navigator.maxTouchPoints > 2 &&
        /MacIntel/.test(navigator.platform))
    );
  }

  static get deviceGrade(): DeviceGrade {
    if ("deviceMemory" in navigator && "hardwareConcurrency" in navigator) {
      if (
        navigator.hardwareConcurrency >= 4 &&
        (navigator as any).deviceMemory >= 8
      ) {
        return DeviceGrade.High;
      }
      if (
        navigator.hardwareConcurrency >= 2 &&
        (navigator as any).deviceMemory >= 4
      ) {
        return DeviceGrade.Medium;
      }
      return DeviceGrade.Low;
    }

    if ("hardwareConcurrency" in navigator) {
      if (navigator.hardwareConcurrency >= 4) {
        return DeviceGrade.High;
      }
      if (navigator.hardwareConcurrency >= 2) {
        return DeviceGrade.Medium;
      }
      return DeviceGrade.Low;
    }

    return DeviceGrade.Unknown;
  }

  static get isSafari(): boolean {
    return (
      navigator.userAgent.toLowerCase().indexOf("safari") > -1 &&
      navigator.userAgent.toLowerCase().indexOf("chrome") === -1
    );
  }

  static get videoFrameCallbackSupport(): boolean {
    return "requestVideoFrameCallback" in HTMLVideoElement.prototype;
  }

  static get arQuicklookSupport(): boolean {
    if (arQuicklookSupport === undefined) {
      const testAnchor = document.createElement("a");
      arQuicklookSupport = testAnchor.relList.supports("ar");
    }

    return arQuicklookSupport;
  }
}

export default DeviceGradeDetection;
